// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".localization-dropdown[data-v-7c15f347] .header-dropdown-menu{width:auto}.localization-dropdown .dropdown-localization[data-v-7c15f347]{margin-bottom:5px}.localization-dropdown .lang-text[data-v-7c15f347]{color:#000;padding:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
